import {
  NEW_JOB_LIST_REQUEST, NEW_JOB_LIST_FAIL, NEW_JOB_LIST_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const NewJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_JOB_LIST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case NEW_JOB_LIST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case NEW_JOB_LIST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default NewJobReducer;
